import axios from "axios";
import config from "../config";

let instance = axios.create({
  baseURL: config.host,
});
// 添加请求拦截器
instance.interceptors.request.use(
  function(config) {
    // token认证
    let token = window.localStorage.getItem("token");
    config.headers.Authorization = token ? "Bearer " + token : "";

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    console.log(response);
    if (response.data.code != "0") {
      return Promise.reject(response.data);
    }
    // 对响应数据做点什么
    return response.data;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default {
  //添加访员
  ///api/v1/interviewer-user/addintervieweruser
  AddInterviewerUser: function(data) {
    return instance.post("/api/v1/interviewer-user/addintervieweruser", data);
  },

  //访员列表
  //api/v1/interviewer-user/queryintervieweruserpage
  InterviewerUserList: function(pageIndex, pageSize, userName) {
    return instance.post(
      `/api/v1/interviewer-user/queryintervieweruserpage?pageIndex=${pageIndex}&pageSize=${pageSize}`,
      { userName }
    );
  },
  //删除访员信息
  //api/v1/interviewer-user/delintervieweruser
  DelInterviewerUser: function(ids) {
    return instance.post(`/api/v1/interviewer-user/delintervieweruser`, {
      interviewerUserUserIdList: [...ids],
    });
  },
  // 修改单个访员信息
  // /api/v1/interviewer-user/updateoneintervieweruser
  UpdateInterviewerUser: function(data) {
    return instance.post(
      `/api/v1/interviewer-user/updateoneintervieweruser`,
      data
    );
  },
  // 修改用户密码
  ///api/v1/interviewer-user/updatepassword
  UpdatePassword: function(data) {
    return instance.post(`/api/v1/interviewer-user/updatepassword`, data);
  },
  //上传访员信息文件
  //api/v1/interviewer-user/uploadyIntervieweruser
  AddInterviewerUserByFile: function(file) {
    let config = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    let form = new FormData();
    form.append("multipartFile", file);
    return instance.post(
      `/api/v1/interviewer-user/uploadyIntervieweruser`,
      form,
      config
    );
  },
  //设置访员分配
  //api/v1/interviewer-user/intervieweruserdistribution
  AssignInterviewUser: function(data) {
    return instance.post(
      `/api/v1/interviewer-user/intervieweruserdistribution`,
      data
    );
  },
  //查询已分配访员信息列表分页
  ///api/v1/interviewer-user/queryintervieweruserdistributionpage
  QueryAssignInterviewUser: function(pageIndex, pageSize, wj_id, userName) {
    return instance.post(
      `/api/v1/interviewer-user/queryintervieweruserdistributionpage?pageIndex=${pageIndex}&pageSize=${pageSize}`,
      { id: wj_id, userName }
    );
  },
  // 取消访员分配
  ///api/v1/interviewer-user/interviewerusercanceldistribution
  UnAssignInterviewUser: function(data) {
    return instance.post(
      `/api/v1/interviewer-user/interviewerusercanceldistribution`,
      data
    );
  },
  //api/v1/user/wechat/wechatLoginCallBack
  //微信登录
  WxLogin: function(code, state) {
    return instance.get(
      `/api/v1/user/wechat/wechatLoginCallBack?code=${code}&state=${state}`
    );
  },
  //设置问卷状态
  ///api/v1/questionnaire/updastate
  //data:{id: "2c9a4m4", state: 1}
  UpdateQuestionnaireState: function(data) {
    return instance.post(
      `/api/v1/questionnaire/updastate`,
      data
    );
  },
  //修改定位题是否为自动定位，manualSetting:1为手动定位，0为自动定位
  ///api/v1/questions/setManualSetting
  SetManualSetting: function(id,manualSetting) {
    return instance.post(
      `/api/v1/questions/setManualSetting`,
      {id,manualSetting}
    );
  },
  //题目排序
  //api/v1/questions/questionsRank
  /**
   * @param {*} id 
   * @param {*} questionRanks [{
   *  "id": "string",
      "orders": 0,
      "pageNumber": 0}]
   */
  questionsRank: function(id,questionRanks) {
    return instance.post(
      `/api/v1/questions/questionsRank`,
      {id,questionRanks}
    );
  },
  //api/v1/questions-option/optionRank
  //选项排序
  /**
   * 
    groupId	string页码
    id	string 题目ID
    orders	排序
   */
  optionRank: function(questionRanks) {
    return instance.post(
      `/api/v1/questions-option/optionRank`,
      questionRanks
    );
  },
};
